import { FC } from 'react';
import { Close } from '@mui/icons-material';
import { clsx } from 'clsx';

import './CalendlyLifestackLogo.scss';
import { ReactComponent as CalendlyLogo } from '../../../assets/icons/calendly_color.svg';
import LifestackLogo from '../../../assets/logo/logo_transparent.png';

interface CalendlyLifestackLogoProps {
  logoWidth?: string;
  className?: string;
}

const CalendlyLifestackLogo: FC<CalendlyLifestackLogoProps> = ({
  logoWidth = '20px',
  className,
}) => {
  return (
    <div className={clsx('calendly-lifestack-logo', className)}>
      <CalendlyLogo style={{ width: logoWidth, height: logoWidth }} />
      <Close fontSize="small" style={{ color: '#b5b5bc' }} />
      <img src={LifestackLogo} alt="lifestack logo" style={{ width: logoWidth }} />
    </div>
  );
};

export default CalendlyLifestackLogo;
